import { useState } from "react";
import { Button, Input } from "antd";

const DynamicInputList = ({ value, onValueChange }) => {
  const [inputs, setInputs] = useState(value); // สร้าง state สำหรับเก็บค่า input

  const handleInputChange = (index, event) => {
    const newInputs = [...inputs];
    newInputs[index] = event.target.value;
    setInputs(newInputs);
    onValueChange(newInputs);
  };

  const handleAddInput = () => {
    const newInputs = [...inputs, ""];
    setInputs(newInputs);
    onValueChange(newInputs);
  };

  const handleRemoveInput = (index) => {
    const newInputs = [...inputs];
    newInputs.splice(index, 1);
    setInputs(newInputs);
    onValueChange(newInputs);
  };

  return (
    <div>
      {inputs.map((input, index) => (
        <div key={index} className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 mt-2">
          <Input
            placeholder="คำถาม"
            key={index}
            value={input}
            onChange={(event) => handleInputChange(index, event)}
            className="flex-1"
          />
          <Button
            type="primary"
            danger
            size={window.innerWidth < 768 ? "small" : "middle"}
            onClick={() => handleRemoveInput(index)}
            className="w-full sm:w-auto"
          >
            ลบ
          </Button>
        </div>
      ))}
      <Button 
        className="mt-3 w-full sm:w-auto" 
        type="primary" 
        size={window.innerWidth < 768 ? "small" : "middle"}
        onClick={handleAddInput}
      >
        + เพิ่มคำถาม
      </Button>
    </div>
  );
};

export default DynamicInputList;
